import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EncryptStorage } from 'encrypt-storage';
import { NzModalService } from 'ng-zorro-antd';
import { of, Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { Config } from 'src/environments/config';
import { RefreshToken, User } from '../models/auth-user';
import {
  Address,
  AppCode, appCodeColor, AppCodeForCreate, AppCodeName, AppCodes, appCodeValue, currencyForAppCode, emptyFields, InstanceName,
  LiveAppCodeCADForCreate,
  LiveAppCodeForCAD,
  LiveAppCodeForPHP, LiveAppCodeForSG, LiveAppCodePHPForCreate, LiveAppCodeSGForCreate, MerchantPaymentMethods, MerchantSettlementColor, MerchantSettlementText, PaymentMethodColor, remittanceProviders, Status, StatusText, UATAppCodeCAD, UATAppCodeForCreateCAD, UATAppCodeForCreatePHP, UATAppCodeForCreateSG,
  UATAppcodeForJufu, UATAppcodeForJufuCreate, UATPHLAppCode, UATSGAppCode, AppCodeForBizBoard
} from '../utilities/common-file';
import { AuthRoutes } from '../utilities/routes';
import * as urls from '../utilities/urls';
export const encryptStorage = EncryptStorage('secret_key', {
  storageType: 'localStorage'
});
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private httpClient: HttpClient, private router: Router, private modalService: NzModalService) {
  }
  private static AUTH_USER = 'AUTH_USER';
  private static AUTH_USER_ID = 'AUTH_USER_ID';
  private static AUTH_USER_DISPLAY_NAME = 'AUTH_USER_DISPLAY_NAME';
  private static AUTH_TOKEN = 'AUTH_TOKEN';
  private static REFRESH_TOKEN = 'REFRESH_TOKEN';
  private static AUTH_USER_ROLE = 'AUTH_USER_ROLE';
  private static AUTH_USER_ROLE_ID = 'AUTH_USER_ROLE_ID';
  private static AUTH_USER_DASHBOARD = 'AUTH_USER_DASHBOARD';
  private static AUTH_USER_TYPE = 'AUTH_USER_TYPE';
  private static AUTH_USER_APPCODE = 'AUTH_USER_APPCODE';
  private static AUTH_USER_UAPPCODE = 'AUTH_USER_UAPPCODE';
  private static AUTH_USER_EMAIL = 'AUTH_USER_EMAIL';
  private static AUTH_USER_PASSWORD = 'AUTH_USER_PASSWORD';
  private static AUTH_USER_REMEMBERME = 'AUTH_USER_REMEMBERME';
  private static AUTH_ACCESS_MODULES = 'AUTH_ACCESS_MODULES';
  private static DEVICE_SIGNATURE = 'DEVICE_SIGNATURE';
  private static COUNTRIES = 'COUNTRIES';
  private static NATIONALITIES = 'NATIONALITIES';
  private static USER_LOGOUT = 'USER_LOGOUT';
  private static ACCESS_TOKEN_REMIT = 'ACCESS_TOKEN_REMIT';


  accessModuleList = [];
  isRememeberMe = false;
  public jwtHelper: JwtHelperService = new JwtHelperService();
  public notify: Subject<boolean> = new Subject<boolean>();
  appCode = AppCode;


  // login(value: any): Observable<User> {
  //   return this.httpClient.post<User>(urls.AuthUrls.login, value).pipe(tap((authUser) => {
  //     if (value.rememberMe) {
  //       this.isRememeberMe = value.rememberMe;
  //       encryptStorage.clear();
  //       encryptStorage.setItem(AuthService.AUTH_USER_REMEMBERME, value.rememberMe);
  //       encryptStorage.setItem(AuthService.AUTH_USER_PASSWORD, value.password);
  //       if (authUser.message === 'OTP is already sent to your device. Please contact customer support') {
  //         this.router.navigate([AuthRoutes.otpVerify + value.email]);
  //       } else if (authUser && authUser.data && authUser.data.isOTPSent) {
  //         this.router.navigate([AuthRoutes.otpVerify + value.email]);
  //       } else {
  //         this.setUser(authUser);
  //       }

  //     } else {
  //       this.isRememeberMe = false;
  //       encryptStorage.clear();
  //       if (authUser.message === 'OTP is already sent to your device. Please contact customer support') {
  //         this.router.navigate([AuthRoutes.otpVerify + value.email]);
  //       } else if (authUser && authUser.data && authUser.data.isOTPSent) {
  //         this.router.navigate([AuthRoutes.otpVerify + value.email]);
  //       } else {
  //         this.setUser(authUser);
  //       }
  //     }
  //   }));
  // }
  // refreshTokens(): Observable<RefreshToken> {
  //   return new Observable(subscriber => {
  //     this.httpClient.get(urls.AuthUrls.refreshTokens)
  //       .pipe(tap((refreshToken: any) => {
  //         this.setRefreshToken(refreshToken.data.refreshToken);
  //       }))
  //       .subscribe(authUser => {
  //         subscriber.next(authUser);
  //         subscriber.complete();
  //       });
  //   });
  // }

  // refreshTokens(): Observable<any> {
  //   return this.httpClient.get(urls.AuthUrls.refreshTokens).pipe(
  //     tap((refreshToken: any) => {
  //       this.setRefreshToken(refreshToken.data.refreshToken);
  //     }),
  //     switchMap(() => {
  //       // const value = {
  //       //   "clientId": "db2e0456-d599-4553-be1f-730e5f2ebe46",
  //       //   "clientSecret": "ee0f131d-4d2e-43f9-900d-5cdec2098b31"
  //       // }
  //       const value = {
  //         "clientId": Config.clientIdRemit,
  //         "clientSecret": Config.clientSecretRemit

  //       }
  //       return this.httpClient.post(urls.AuthUrls.authenticationRemit, value).pipe(
  //         tap((accessTokenRemit: any) => {
  //           this.setAccessTokenRemit(accessTokenRemit.data.access_token);
  //         })
  //       );
  //     })
  //   );
  // }

  login(value: any): Observable<User> {
  return this.httpClient.post<User>(urls.AuthUrls.login, value).pipe(
    tap((response: any) => {
      if (!response || !response.success || !response.data) {
        return;
      }

      const data = response.data;

      // Existing Remember Me functionality
      this.isRememeberMe = !!value.rememberMe;

      if (value.rememberMe) {
        encryptStorage.setItem(
          AuthService.AUTH_USER_REMEMBERME,
          true
        );
        encryptStorage.setItem(
          AuthService.AUTH_USER_EMAIL,
          value.email
        );
        encryptStorage.setItem(
          AuthService.AUTH_USER_PASSWORD,
          value.password
        );
      } else {
        encryptStorage.setItem(
          AuthService.AUTH_USER_REMEMBERME,
          false
        );
        encryptStorage.removeItem(
          AuthService.AUTH_USER_PASSWORD
        );
      }

      // Existing direct login
      if (data.customToken) {
        this.setUser(response);
      }

      // OTP response:
      // Do not setUser or navigate here.
      // LoginComponent will handle navigation.
    })
  );
}

   refreshTokens(): Observable<any> {
  return this.httpClient.get(urls.AuthUrls.refreshTokens).pipe(
    tap((refreshToken: any) => {
      this.setRefreshToken(refreshToken.data.refreshToken);
    }),

    switchMap((mainResponse: any) => {
      const value = {
        clientId: Config.clientIdRemit,
        clientSecret: Config.clientSecretRemit
      };

      return this.httpClient
        .post(urls.AuthUrls.authenticationRemit, value)
        .pipe(
          tap((accessTokenRemit: any) => {
            if (
              accessTokenRemit &&
              accessTokenRemit.data &&
              accessTokenRemit.data.access_token
            ) {
              this.setAccessTokenRemit(
                accessTokenRemit.data.access_token
              );
            }
          }),

          // IMPORTANT
          // If remit auth fails, continue app login

          catchError((err) => {
            console.error('Remit token failed', err);
            // optional
            this.setAccessTokenRemit(null);
            // continue login flow
            return of(null);

          }),
          // return original response
          map(() => mainResponse)
        );

    })

  );
}

  refreshCustomTokens(): Observable<any> {
    return new Observable(subscriber => {
      this.httpClient
        .post<any>(urls.AuthUrls.refreshCustomToken, {
          refreshToken: this.getRefreshToken(),
        })
        .pipe(tap((authUser) => {
          // tslint:disable-next-line: no-non-null-assertion
          if (authUser.data && authUser.data.refresh_token && authUser.data.refresh_token !== '') {
            this.setAuthToken(authUser.data.refresh_token);
          } else {
            this.onNotify(true);
            encryptStorage.clear();
            this.router.navigate([AuthRoutes.login]);
            this.showMessage();
          }
        }))
        .subscribe(authUser => {
          subscriber.next(authUser);
          subscriber.complete();
        });
    });
  }

  refreshRemitTokens(): Observable<any> {
    return new Observable(subscriber => {
      this.httpClient
        .post<any>(urls.AuthUrls.authenticationRemit, {
          "clientId": Config.clientIdRemit,
          "clientSecret": Config.clientSecretRemit
        })
        .pipe(tap((authUser) => {
          // tslint:disable-next-line: no-non-null-assertion
          if (authUser.data && authUser.data.access_token && authUser.data.access_token !== '') {
            this.setAccessTokenRemit(authUser.data.access_token);
          } else {
            this.onNotify(true);
            encryptStorage.clear();
            this.router.navigate([AuthRoutes.login]);
            this.showMessage();
          }
        }))
        .subscribe(authUser => {
          subscriber.next(authUser);
          subscriber.complete();
        });
    });
  }



 verifyOTP(value: any): Observable<any> {
  return this.httpClient.post<any>(
    urls.AuthUrls.verifyOTP,
    value
  ).pipe(
    tap((response: any) => {
      if (
        response &&
        response.success === true &&
        response.data &&
        response.data.customToken
      ) {
        this.setUser(response);
      }
    })
  );
}

 resendOTP(value) {
  return this.httpClient.post(
    urls.AuthUrls.resendOTP,
    value
  );
}

  forgetPassword(value) {
    return this.httpClient.post(urls.AuthUrls.forgetPassword, value);
  }
  resetPassword(value) {
    return this.httpClient.post(urls.AuthUrls.resetPassword, value);
  }
  validateToken(value) {
    return this.httpClient.post(urls.AuthUrls.tokenValidate, value);
  }
  private setUser(authUser) {

    encryptStorage.setItem(AuthService.AUTH_USER, JSON.stringify(authUser));
    encryptStorage.setItem(AuthService.AUTH_USER_UAPPCODE, authUser.data.appCode);
    encryptStorage.setItem(AuthService.AUTH_USER_ID, authUser.data.id);
    encryptStorage.setItem(AuthService.AUTH_USER_EMAIL, authUser.data.email);
    encryptStorage.setItem(AuthService.AUTH_USER_DISPLAY_NAME, authUser.data.displayName);
    encryptStorage.setItem(AuthService.AUTH_USER_TYPE, authUser.data.role);
    encryptStorage.setItem(AuthService.AUTH_USER_APPCODE, authUser.data.appCode);
    if (authUser && authUser.data && authUser.data.userRole) {
      encryptStorage.setItem(AuthService.AUTH_USER_ROLE, authUser.data.userRole.roleName);
      encryptStorage.setItem(AuthService.AUTH_USER_DASHBOARD, authUser.data.userRole.dashboard);
    }
    if (authUser && authUser.data && authUser.data.roleId) {
      encryptStorage.setItem(AuthService.AUTH_USER_ROLE_ID, authUser.data.roleId);
    }

    let appCode = '';
    appCode = encryptStorage.getItem(AuthService.AUTH_USER_APPCODE);
    if (appCode === appCodeValue.all) {
      encryptStorage.setItem(AuthService.AUTH_USER_APPCODE, '');
    }
    this.setAuthToken(authUser.data.customToken);
  }

  setDeviceSignature(value) {
    localStorage.setItem(AuthService.DEVICE_SIGNATURE, value);
  }

  getDeviceSignature() {
    return localStorage.getItem(AuthService.DEVICE_SIGNATURE);
  }

  getUAppCode() {
    let appCode = encryptStorage.getItem(AuthService.AUTH_USER_UAPPCODE);
    if (appCode && typeof appCode === 'string' || appCode == '') {
      return encryptStorage.getItem(AuthService.AUTH_USER_UAPPCODE);
    } else {
      return encryptStorage.getItem(AuthService.AUTH_USER_UAPPCODE).toString();
    }
  }

  getUserId(): number {
    return Number(encryptStorage.getItem(AuthService.AUTH_USER_ID));
  }
  getDisplayName(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_DISPLAY_NAME);
  }
  setDisplayName(name: string) {
    encryptStorage.setItem(AuthService.AUTH_USER_DISPLAY_NAME, name);
  }
  getEmail(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_EMAIL);
  }
  getUserType(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_TYPE);
  }
  setLogOutValue(value) {
    sessionStorage.setItem(AuthService.USER_LOGOUT, value)
  }
  getLogOutValue() {
    return sessionStorage.getItem(AuthService.USER_LOGOUT)
  }

  showAppCodeFilter(): boolean {
    let appCode = '';
    appCode = encryptStorage.getItem(AuthService.AUTH_USER_UAPPCODE);
    if (appCode == appCodeValue.all || appCode == appCodeValue.FlexM || appCode == appCodeValue.TorkeyTimes  ) {
      return true;
    } else {
      return false;
    }
  }
  getAppCode() {
    let appCode = encryptStorage.getItem(AuthService.AUTH_USER_APPCODE);
    if (appCode && typeof appCode === 'string' || appCode == '') {
      return encryptStorage.getItem(AuthService.AUTH_USER_APPCODE);
    } else {
      return encryptStorage.getItem(AuthService.AUTH_USER_APPCODE).toString();
    }
  }
  private setAuthToken(token: string) {
    encryptStorage.setItem(AuthService.AUTH_TOKEN, token);
  }

  getAuthToken(): string {
    return encryptStorage.getItem(AuthService.AUTH_TOKEN);
  }

  private setRefreshToken(token: string) {
    encryptStorage.setItem(AuthService.REFRESH_TOKEN, token);
  }

  getRefreshToken(): string {
    return encryptStorage.getItem(AuthService.REFRESH_TOKEN);
  }

  setAccessTokenRemit(token: string) {
    encryptStorage.setItem(AuthService.ACCESS_TOKEN_REMIT, token);
  }
  getAccessTokenRemit(): string {
    return encryptStorage.getItem(AuthService.ACCESS_TOKEN_REMIT);
  }

  getPassword(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_PASSWORD);
  }
  getRememberMe() {
    return encryptStorage.getItem(AuthService.AUTH_USER_REMEMBERME);
  }
  setRoleAccessModule(type: string) {
    encryptStorage.setItem(AuthService.AUTH_ACCESS_MODULES, type);
  }
  getRoleId(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_ROLE_ID);
  }
  getRoleName(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_ROLE);
  }
  getRoleDashboard(): string {
    return encryptStorage.getItem(AuthService.AUTH_USER_DASHBOARD);
  }


  getRoleAccessModule(): string {
    return encryptStorage.getItem(AuthService.AUTH_ACCESS_MODULES);
  }
  logout() {
    return this.httpClient.get<User>(urls.AuthUrls.logout).pipe(tap((authUser) => {
      let userEmail = '';
      let userPassword = '';
      userEmail = this.getEmail();
      userPassword = this.getPassword();
      encryptStorage.clear();
      if (this.isRememeberMe) {
        encryptStorage.setItem(AuthService.AUTH_USER_REMEMBERME, 'true');
        encryptStorage.setItem(AuthService.AUTH_USER_EMAIL, userEmail);
        encryptStorage.setItem(AuthService.AUTH_USER_PASSWORD, userPassword);
      }
      this.router.navigate([AuthRoutes.login]);
    }));
  }
  public isAuthenticated(): boolean {
    const token = encryptStorage.getItem(AuthService.AUTH_TOKEN);
    return token !== null;
  }
  onNotify(event) {
    return this.notify.next(true);
  }
  getAllAppCode(): any {
    if (Config.appCode === InstanceName.dev) {
      return AppCode;
    } else if (Config.appCode === InstanceName.uatSG) {
      return UATSGAppCode;
    } else if (Config.appCode === InstanceName.uatPHP) {
      return UATPHLAppCode;
    } else if (Config.appCode === InstanceName.liveSG) {
      return LiveAppCodeForSG;
    } else if (Config.appCode === InstanceName.livePHP) {
      return LiveAppCodeForPHP;
    } else if (Config.appCode === InstanceName.JufuUAT) {
      return UATAppcodeForJufu;
    } else if (Config.appCode === InstanceName.uatCAD) {
      return UATAppCodeCAD;
    } else if (Config.appCode === InstanceName.liveCAD) {
      return LiveAppCodeForCAD;
    } else if (Config.appCode === InstanceName.flexBiz) {
      return AppCodeForBizBoard;
    }
  }
  getAllAppCodeForCreate(): any {
    if (Config.appCode === InstanceName.dev) {
      return AppCodeForCreate;
    } else if (Config.appCode === InstanceName.uatSG) {
      return UATAppCodeForCreateSG;
    } else if (Config.appCode === InstanceName.uatPHP) {
      return UATAppCodeForCreatePHP;
    } else if (Config.appCode === InstanceName.liveSG) {
      return LiveAppCodeSGForCreate;
    } else if (Config.appCode === InstanceName.livePHP) {
      return LiveAppCodePHPForCreate;
    } else if (Config.appCode === InstanceName.JufuUAT) {
      return UATAppcodeForJufuCreate;
    } else if (Config.appCode === InstanceName.JufuUAT) {
      return UATAppcodeForJufu;
    } else if (Config.appCode === InstanceName.uatCAD) {
      return UATAppCodeForCreateCAD;
    } else if (Config.appCode === InstanceName.liveCAD) {
      return LiveAppCodeCADForCreate;
    } else if (Config.appCode === InstanceName.flexBiz) {
      return AppCodeForBizBoard;
    }
  }
  getColorForAppCodes(data) {
    const key = Object.keys(AppCodes).find(key => AppCodes[key] === data.appCode);
    return appCodeColor[key] ? appCodeColor[key] : 'green';
  }
  getAddressName(data) {
    let address = Address[data.appCode] ? Address[data.appCode] : Address[''];
    return address;
  }
  getSettlementType(data) {
    let type = data ? MerchantSettlementText.merchantSettlement : MerchantSettlementText.locationSettlement;
    return type;
  }
  getSettlementTypeColor(data) {
    let color = data ? MerchantSettlementColor.merchantSettlement : MerchantSettlementColor.locationSettlement;
    return color;
  }
  //To get the wallet status.
  getStatus(data) {
    const key = Object.keys(Status).find(key => Status[key] === data.status);
    return StatusText[key] ? StatusText[key] : emptyFields.NA;
  }
  getUserStatus(status) {
    const key = Object.keys(Status).find(key => Status[key] === status);
    return StatusText[key] ? StatusText[key] : emptyFields.NA;
  }

  getAppCodeName(data) {
    const key = Object.keys(AppCodes).find(key => AppCodes[key] === data.appCode);
    return AppCodeName[key] ? AppCodeName[key] : emptyFields.NA;
  }

  getColorForPaymentMethods(data) {
    const key = Object.keys(MerchantPaymentMethods).find(key => MerchantPaymentMethods[key] === data.paymentMethod);
    return PaymentMethodColor[key] ? PaymentMethodColor[key] : emptyFields.NA;
  }

  getLogoImage(merchantAppCode) {
    if (merchantAppCode === AppCodes.adbUATNew) {
      return 'assets/adb-pay-logo.svg';
    } else if (merchantAppCode === AppCodes.sandboxUAT) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.dev) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.JDee) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.test) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.all) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.BeamAndGo) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.MetroRemit) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.ADBPAY) {
      return 'assets/adb-pay-logo.svg';
    } else if (merchantAppCode === AppCodes.KingsRemit) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.Zhongguo) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.Jufu || merchantAppCode === AppCodes.JufuUAT) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.ATT) {
      return 'assets/group-46.png';
    } else if (merchantAppCode === AppCodes.Connect) {
      return 'assets/connect-logo.svg';
    } else {
      return 'assets/group-46.png';
    }

  }
  // Show currency based on appcode
  getCurrencyBasedOnAppCode(appCode) {
    var index = currencyForAppCode.findIndex(M => M.appCode == appCode);
    if (index !== -1) {
      return currencyForAppCode[index].symbol;
    } else {
      return '$';
    }
  }

  // show Merchant Settlement Repost option based on Instance
  showRepostOptionBasedOnInstance() {
    if (Config.appCode === InstanceName.dev || Config.appCode === InstanceName.uatPHP
      || Config.appCode === InstanceName.livePHP) {
      return true;
    } else {
      return false;
    }
  }
  getModuleGroup(groupName: string) {
    if (this.accessModuleList.length > 0) {
      const index = this.accessModuleList.findIndex(M => M.backofficeModule.groupName.toUpperCase() === groupName.toUpperCase());
      if (index !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  getModuleAccess(moduleName: string) {
    if (this.accessModuleList.length > 0) {
      const index = this.accessModuleList.findIndex(M => M.backofficeModule.moduleName.toUpperCase() === moduleName.toUpperCase());
      if (index !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  getModuleGroupAndModuleAccess(moduleName: string, groupName: string) {
    if (this.accessModuleList.length > 0) {
      const index = this.accessModuleList.findIndex(M => M.backofficeModule.moduleName.toUpperCase() === moduleName.toUpperCase() && M.backofficeModule.groupName.toUpperCase() === groupName.toUpperCase());
      if (index !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  getDecryptModules() {
    if (this.getRoleId()) {
      const accessModules: any = this.getRoleAccessModule();
      this.accessModuleList = accessModules;
    } else {
      this.accessModuleList = [];
    }
  }
  clearDecryptModules() {
    this.accessModuleList = [];
  }
  showMessage() {
    this.modalService.error({
      nzTitle: 'Your Logged in credentials might be changed. So Please log in again with correct credentials',
      nzOkText: 'OK',
      nzOkType: 'danger',
      nzOnOk: () => this.modalService.closeAll()
    });
  }
  getUserGuide() {
    var params = {
      "appCode": this.getAppCode() === '' ? '*' : this.getAppCode(),
      "portalType": "adminboard",
    }
    return this.httpClient.post(urls.UserGuideUrls.list, params);
  }
  getAttachment(value) {
    return this.httpClient.post(urls.AttachmentUrls.listAttachments, value);
  }
  getsqrLogo() {
    return 'assets/adb-pay-store-logo.png';
  }
  setCountryList(value: any) {
    encryptStorage.setItem(AuthService.COUNTRIES, value);
  }
  getCountryList() {
    return encryptStorage.getItem(AuthService.COUNTRIES);
  }
  setNationalityList(value: any) {
    encryptStorage.setItem(AuthService.NATIONALITIES, value);
  }
  getNationalityList() {
    return encryptStorage.getItem(AuthService.NATIONALITIES);
  }
  // To Show Create, Edit, delete Access Based on Provider
  showAccessBasedOnProvider(providerId) {
    // const providerId = this.getProviderId();
    if (providerId === remittanceProviders.iPay || providerId === remittanceProviders.agrani || providerId === remittanceProviders.jufu) {
      return true;
    } else {
      return true;
    }
  }

  getValueForStatusFilterBasedOnProvider(providerId) {
    // const providerId = this.getProviderId();
    if (providerId === remittanceProviders.iPay) {
      return '';
    } else {
      return '';
    }
  }
}
